export const messages = {
  en: {
    repairPoolManage: {
      queryConditions: 'Query Conditions',
      repairOrderPool: 'Repair Order Pool',
      workOrderCode: 'Work Order Code',
      location: 'Location',
      repairType: 'Repair Type',
      maintenanceType: 'Maintenance Type',
      repairPerson: 'Repair Person',
      contact: 'Contact',
      appointmentTime: 'Appointment Time',
      submissionTime: 'Submission Time',
      submissionDuration: 'Submission Duration',
      completionTime: 'Completion Time',
      status: 'Status',
      operation: 'Operation',
      modify: 'Modify',
      dispatch: 'Dispatch',
      grabOrder: 'Grab Order',
      end: 'End',
      details: 'Details',
      delete: 'Delete',
      search: 'Search',
      reset: 'Reset',
      more: 'More',
      hide: 'Hide',
      all: 'All',
      timeoutOrders: 'Timeout Orders',
      workOrderNumber: 'Work Order Number',
      repairPersonName: 'Repair Person Name',
      repairPhone: 'Repair Phone',
      selectRepairType: 'Select Repair Type',
      selectRepairSettingType: 'Select Repair Setting Type',
      repairLocation: 'Repair Location',
      selectMaintenanceType: 'Select Maintenance Type',
      startTime: 'Start Time',
      endTime: 'End Time',
      repairSettingType: 'Repair Setting Type',
      repairContent: 'Repair Content',
      operationSuggestions: 'Operation Suggestions',
      endReason: 'End Reason',
      paidService: 'Paid Service',
      freeService: 'Free Service',
      needMaterials: 'Need Materials',
      noMaterialsNeeded: 'No Materials Needed',
      timedTaskProcessing: 'Timed Task Processing',
      cannotTransferSelf:' can not transfer to yourself'
    }
  },
  zh: {
    repairPoolManage: {
      queryConditions: '查询条件',
      repairOrderPool: '报修工单池',
      workOrderCode: '工单编码',
      location: '位置',
      repairType: '报修类型',
      maintenanceType: '维修类型',
      repairPerson: '报修人',
      contact: '联系方式',
      appointmentTime: '预约时间',
      submissionTime: '提交时间',
      submissionDuration: '提单时长',
      completionTime: '完成时间',
      status: '状态',
      operation: '操作',
      modify: '修改',
      dispatch: '派单',
      grabOrder: '抢单',
      end: '结束',
      details: '详情',
      delete: '删除',
      search: '查询',
      reset: '重置',
      more: '更多',
      hide: '隐藏',
      all: '全部',
      timeoutOrders: '超时工单',
      workOrderNumber: '工单编号',
      repairPersonName: '报修人',
      repairPhone: '报修电话',
      selectRepairType: '请选择报修类型',
      selectRepairSettingType: '请选择报修设置类型',
      repairLocation: '报修位置',
      selectMaintenanceType: '请选择维修类型',
      startTime: '开始时间',
      endTime: '结束时间',
      repairSettingType: '报修设置类型',
      repairContent: '报修内容',
      operationSuggestions: '说明',
      endReason: '结束原因',
      paidService: '付费服务',
      freeService: '免费服务',
      needMaterials: '需要材料',
      noMaterialsNeeded: '不需要材料',
      timedTaskProcessing: '定时任务处理中',
cannotTransferSelf: '不能转单给自己'
    }
  },
  'zh-TW': {
    repairPoolManage: {
      queryConditions: '查詢條件',
      repairOrderPool: '報修工單池',
      workOrderCode: '工單編碼',
      location: '位置',
      repairType: '報修類型',
      maintenanceType: '維修類型',
      repairPerson: '報修人',
      contact: '聯繫方式',
      appointmentTime: '預約時間',
      submissionTime: '提交時間',
      submissionDuration: '提單時長',
      completionTime: '完成時間',
      status: '狀態',
      operation: '操作',
      modify: '修改',
      dispatch: '派單',
      grabOrder: '搶單',
      end: '結束',
      details: '詳情',
      delete: '刪除',
      search: '查詢',
      reset: '重設',
      more: '更多',
      hide: '隱藏',
      all: '全部',
      timeoutOrders: '超時工單',
      workOrderNumber: '工單編號',
      repairPersonName: '報修人',
      repairPhone: '報修電話',
      selectRepairType: '請選擇報修類型',
      selectRepairSettingType: '請選擇報修設置類型',
      repairLocation: '報修位置',
      selectMaintenanceType: '請選擇維修類型',
      startTime: '開始時間',
      endTime: '結束時間',
      repairSettingType: '報修設置類型',
      repairContent: '報修內容',
      operationSuggestions: '說明',
      endReason: '結束原因',
      paidService: '付費服務',
      freeService: '免費服務',
      needMaterials: '需要材料',
      noMaterialsNeeded: '不需要材料',
      timedTaskProcessing: '定時任務處理中',
      cannotTransferSelf: '不能轉單給自己'
    }
  }
}